import {
  GET_USER_VENDOR_TEMPLATES_DETAILS,
  GET_SMS_TEMPLATES,
  GET_EMAIL_TEMPLATES,
  GET_NOTIFICATION_TEMPLATES,
  GET_IN_APP_TEMPLATES,
  GET_SINGLE_TEMPLATES,
  UPDATE_IN_APP_TEMPLATES,
  GET_VENDOR_TEMPLATES_DETAILS,
  GET_USER_TEMPLATES_DETAILS,
  EDIT_IN_APP_TEMPLATES,
} from "../../types";

const initialState = {
  get_user_vendor_info: [],
  getSmsTemplates: [],
  getEmailTemplates: [],
  getNotificationTemplates: [],
  getInAppTemplates: [],
  getSingleTemplate: {},
  users: [],
  vendors: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_USER_VENDOR_TEMPLATES_DETAILS:
      return {
        ...state,
        get_user_vendor_info: action.payload,
      };
    case GET_VENDOR_TEMPLATES_DETAILS:
      return {
        ...state,
        vendors: action.payload,
      };
    case GET_USER_TEMPLATES_DETAILS:
      return {
        ...state,
        users: action.payload,
      };
    case GET_SMS_TEMPLATES:
      return {
        ...state,
        getSmsTemplates: action.payload,
      };
    case GET_EMAIL_TEMPLATES:
      return {
        ...state,
        getEmailTemplates: action.payload,
      };
    case GET_NOTIFICATION_TEMPLATES:
      return {
        ...state,
        getNotificationTemplates: action.payload,
      };
    case GET_IN_APP_TEMPLATES:
      return {
        ...state,
        getInAppTemplates: action.payload,
      };
    case UPDATE_IN_APP_TEMPLATES:
      return {
        ...state,
        getInAppTemplates: [action.payload, ...state.getInAppTemplates],
      };
    case EDIT_IN_APP_TEMPLATES:
      let _data = state.getInAppTemplates;
      for (let index = 0; index < _data.length; index++) {
        if (_data[index]?._id === action.payload?.__id)
          _data[index] = action.payload;
      }
      return {
        ...state,
        getInAppTemplates: _data,
      };
    case GET_SINGLE_TEMPLATES:
      return {
        ...state,
        getSingleTemplate: action.payload,
      };

    default:
      return state;
  }
}
